import { DialogComponent } from '@theme/dialog';

/** Reuse the theme's accessible dialog, dismissal, and scroll-lock behavior. */
class GuidesWatchTutorial extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog.addEventListener('close', this.#stopVideo);
  }

  showDialog() {
    if (this.refs.dialog.open) return;

    const player = this.querySelector('.guides-watch-tutorial__player');
    const template = this.querySelector('template');
    if (!template.content.querySelector('video')) return;

    player.replaceChildren(template.content.cloneNode(true));
    super.showDialog();
    // The click supplies user activation. Controls remain available if the
    // browser declines playback (for example, while the video is buffering).
    player.querySelector('video').play().catch(() => {});
  }

  #stopVideo = () => {
    const player = this.querySelector('.guides-watch-tutorial__player');
    const video = player.querySelector('video');
    if (video) {
      video.pause();
      player.replaceChildren();
    }
  };

  disconnectedCallback() {
    this.#stopVideo();
    this.refs.dialog.removeEventListener('close', this.#stopVideo);
    this.refs.dialog.close();
    // Editor section replacement cannot bubble a toggle event to document.
    if (!document.querySelector('dialog[open][scroll-lock], details[open][scroll-lock]')) {
      document.documentElement.removeAttribute('scroll-lock');
    }
    super.disconnectedCallback();
  }
}

if (!customElements.get('guides-watch-tutorial')) {
  customElements.define('guides-watch-tutorial', GuidesWatchTutorial);
}
